import { domReady } from '../modules/utils.js';

class EventsGrid extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();

    this.refs = {
      grid: this.querySelector('.eventsgrid-grid'),
      sentinel: this.querySelector('.eventsgrid-sentinel'),
      loader: this.querySelector('.eventsgrid-loader'),
    };

    this.page = parseInt(this.dataset.page, 10) || 1;
    this.maxPages = parseInt(this.dataset.maxPages, 10) || 1;
    this.perPage = parseInt(this.dataset.perPage, 10) || 9;
    this.excludeId = this.dataset.exclude || '';
    this.filter = this.dataset.filter || '';
    this.isLoading = false;

    if (!this.refs.sentinel || !this.refs.grid || this.page >= this.maxPages) return;

    this.observer = new IntersectionObserver(this.#onIntersect, { rootMargin: '400px 0px' });
    this.observer.observe(this.refs.sentinel);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  #onIntersect = (entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      this.#loadMore();
    }
  };

  #loadMore = async () => {
    if (this.isLoading || this.page >= this.maxPages) return;
    if (!window.mtsEventsGrid) return;

    this.isLoading = true;
    this.refs.loader?.removeAttribute('hidden');

    const nextPage = this.page + 1;
    const body = new URLSearchParams({
      action: 'mts_events_grid_load_more',
      nonce: window.mtsEventsGrid.nonce,
      page: nextPage,
      per_page: this.perPage,
      filter: this.filter,
      'exclude[]': this.excludeId,
    });

    try {
      const response = await fetch(window.mtsEventsGrid.ajaxUrl, {
        method: 'POST',
        body,
      });
      const result = await response.json();

      if (result?.success && result.data?.html) {
        this.refs.grid.insertAdjacentHTML('beforeend', result.data.html);
        this.page = nextPage;

        if (!result.data.hasMore) {
          this.observer?.disconnect();
        }
      } else {
        this.observer?.disconnect();
      }
    } catch {
      this.observer?.disconnect();
    } finally {
      this.isLoading = false;
      this.refs.loader?.setAttribute('hidden', '');
    }
  };
}

customElements.define('events-grid', EventsGrid);
